import React from 'react';
import Button from '../root/components/buttons/Button';
import Link from '../root/components/Link';
import styles from './PromoBanner.module.scss';

export const PromoBanner: React.FC<{ onBtnClick?: () => void }> = ({ onBtnClick }) => {
  return (
    <div className={styles.promoBannerBg}>
      <div className={styles.promoBanner}>
        <div style={{ marginBottom: -10 }}>
          <h2>
            anniversary <span>sale</span>
          </h2>
        </div>
        <div className={styles.bannerMessage} style={{ flex: 1 }}>
          Up to 50% off
        </div>

        <div>
          {onBtnClick ? (
            <Button
              text={'Shop now'}
              dataTrackLabel="Discount products"
              dataTrackLocation="Home page promo"
              buttonType={'secondary'}
              size={'small'}
              onClick={onBtnClick}
            />
          ) : (
            <Link
              text={'Shop now'}
              dataTrackLabel="Discount products"
              dataTrackLocation="Home page promo"
              buttonType={'secondary'}
              size={'small'}
              href="/products"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
